import { AppErrorInterface } from 'Context/ErrorModalContext'
import React from 'react'
import { Modal, Button, Alert } from 'react-bootstrap'

interface Props {
    error: AppErrorInterface | null
    onClose: () => void
}

const ErrorModal: React.FC<Props> = ({ error, onClose }) => {
    if (!error) return null

    return (
        <Modal
            show
            onHide={onClose}
            centered
            backdrop="static"
            style={{ backgroundColor: 'rgba(1,1,1,0.5)' }}
        >
            <Modal.Header closeButton={false} className="modal-header-danger">
                <Modal.Title style={{color:'white', fontWeight: 'bold'}}>
                    {error.title || 'Ocurrió un error'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert variant="danger" className="mb-2">
                    {error.message}
                </Alert>

                {error.detail && (
                    <div className="text-muted small">
                        {error.detail}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ErrorModal
